import { ENTITY_API_URL } from "../environment";
import { initAxiosFor } from "../security/axiosUtils";

export function useIntegrationDataService() {
  const axiosInstance = initAxiosFor(ENTITY_API_URL);
  return {
    getAll: async (tenantId: string) =>
      (await axiosInstance.get(`/api/IntegrationData?tenantId=${tenantId}`))?.data,
    post: async (value: any) =>
      (await axiosInstance.post(`/api/IntegrationData`, value))?.data,
    delete: async (id: string) =>
      await axiosInstance.delete(`/api/IntegrationData/${id}`),
  };
}
